import { render, staticRenderFns } from "./dictselect.vue?vue&type=template&id=4fcd5cda"
import script from "./dictselect.vue?vue&type=script&lang=ts"
export * from "./dictselect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports